<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Alasan Reject Gadai</h5>
            </template>
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group
                    label="Filter"
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex search-input-wrapper">
                        <b-form-input class="ml-2 mr-2"
                            v-model="input.filterName" name="filterTable"
                            id="filterInput"
                            type="search"
                            placeholder="Type to search"
                            @keyup.enter="onFilter()" 
                        ></b-form-input>

                        <b-form-select class="ml-2 mr-2" v-model="input.filterRequirePhoto" id="filterRequirePhoto" name="filterRequirePhoto" value-field="id" text-field="name">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Pilih Require Foto --</b-form-select-option>
                                <b-form-select-option :value="true" >Wajib Minimal 1 Foto</b-form-select-option>
                                <b-form-select-option :value="false" >Opsional</b-form-select-option>
                            </template>
                        </b-form-select>

                        <b-form-select class="ml-2 mr-2" v-model="input.filterIsActive" id="filterIsActive" name="filterIsActive" value-field="id" text-field="name">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Pilih filter aktif --</b-form-select-option>
                                <b-form-select-option :value="true" >Aktif</b-form-select-option>
                                <b-form-select-option :value="false" >Non-Aktif</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter()"> 
                            <i class="fa fa-search"></i>
                        </b-button>
                        <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset()">Reset</b-button>
                    </div>
                </b-form-group>
                <div>
                    <!-- <b-button class="mb-3 mr-2" variant="pgiBtn" name="roleAddBtn" @click="inputSE">Surat Edaran</b-button> -->
                    <b-button class="mb-3" variant="pgiBtn" name="roleAddBtn" @click="inputalasan">Input Alasan</b-button>
                </div>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="alasan" 
                :fields="fields"
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data Alasan.
                </template>
                <template v-slot:cell(status)="row">
                    <div class="no-wrap">
                        <b-badge v-if="row.item.requirePhoto" variant="primary">Wajib Minimal 1 Foto</b-badge>
                        <b-badge v-if="!row.item.requirePhoto" variant="dark"> Foto Opsional</b-badge>
                    </div>
                </template>
                <template v-slot:cell(isActive)="row">
                    <b-badge v-if="row.item.isActive" variant="success">Aktif</b-badge>
                    <b-badge v-else variant="danger">Non-Aktif</b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-button size="sm" class="table-button edit mr-2" v-b-tooltip.hover title="Edit" name="userStaffEditBtn" @click="editalasan(row.item)">
                            <i class="fa fa-pencil-square-o"></i>
                        </b-button>
                        <b-button @click="confSwitchStatus(row.item.id)" size="sm" variant="success" :variant="row.item.isActive ?'danger' :'success'" v-b-tooltip.hover :title="row.item.isActive ?'Non-Aktifkan' :'Aktifkan'">
                            <i class="fa fa-power-off"></i>
                        </b-button>    
                    </div>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" :options="options" @change="onLimitChange">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>

            <b-modal id="modal-tambah-alasan" title="Tambah Alasan">
                <b-form-group label="Nama Alasan">
                    <b-form-input
                        v-model="form.alasan"
                        placeholder="Masukan Nama Alasan"
                        required
                    ></b-form-input>
                    
                    <b-form-checkbox
                        class="mt-3"
                        id="requireFoto"
                        v-model="form.requireFoto"
                        name="requireFoto"
                        >
                        Checklist Jika Perlu Foto 
                    </b-form-checkbox>
                </b-form-group>

                <template v-slot:modal-footer="{ ok }">

                    <b-button variant="primary" name="submitBtn" @click="confirmInput" :disabled="isSubmitting">
                        {{ isSubmitting ? "Loading" : "Submit" }}
                    </b-button>
                </template>
            </b-modal>


            <b-modal id="modal-edit-alasan" title="Ubah Alasan">
                <b-form-group label="Nama Alasan">
                    <b-form-input
                        v-model="formEdit.alasan"
                        placeholder="Masukan Nama Alasan"
                        required
                    ></b-form-input>
                 
                    <b-form-checkbox
                        class="mt-3"
                        id="editRequireFoto"
                        v-model="formEdit.requireFoto"
                        name="requireFoto"
                    >
                        Checklist Jika Perlu Foto 
                    </b-form-checkbox>
                </b-form-group>

                <template v-slot:modal-footer="{ ok }">
                    <b-button variant="primary" name="submitBtn" @click="confirmEdit" :disabled="isSubmitting">
                        {{ isSubmitting ? "Loading" : "Submit" }}
                    </b-button>
                </template>
            </b-modal>


            <ModalConfirm id="modal-confirm-input" title="Confirm input Alasan" :isSubmitting="isSubmitting"
            desc="Apakah anda yakin untuk menginput Alasan ini?" @submit="submit" />

            <ModalConfirm id="modal-confirm-edit" title="Confirm ubah Alasan" :isSubmitting="isSubmitting"
            desc="Apakah anda yakin untuk mengubah Alasan ini?" @submit="submitEdit" />

            <ModalConfirm id="conf-switch-status" title="Confirm Ubah Status Informasi Umum" :isSubmitting="isSubmitting" desc="Apakah kamu yakin untuk mengubah status informasi ini?" @submit="onSwitchStatus()" />

        </b-card>
    </div>
</template>

<script>
export default {
    name: 'alasan-reject-gadai',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            input:{
                show: 10,
                filterName: "",
                filterRequirePhoto: null,
                filterIsActive:null
            },
            form:{
                alasan: "",
                requireFoto: true,
            },
            formEdit:{
                alasan: "",
                requireFoto: true,
            },
            fields: [
                { key: "name", label: "Nama", sortable:true},
                { key: "status", label: "Status"},
                { key: "isActive", label: "Aktif"},
                { key: "action", label: "Aksi"}
            ],
            filter: null,
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
          
            activeId : null,
            alasan: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            query: "",
        

            isSubmitting:false
        }
    }, 
    
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)


            let getAlasan = this.$axios.get("gadai-reject-reason/"+this.query).then(response => {
                this.alasan = response.data.data
                this.updateTotalItem(response.data.total)

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getAlasan]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },


        //-----------------  Fungsi Ambil Data Role ----------------- 
        
        onFilter(){
            this.page = 0
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getAlasan()
        },

        getAlasan(){
            this.toggleBusy()

            if(!this.$helper.isNullOrEmpty(this.input.filterName)) this.query = this.query + "&filterName=" + this.input.filterName
            if(this.input.filterRequirePhoto != null) this.query = this.query + "&filterRequirePhoto=" + this.input.filterRequirePhoto
            if(this.input.filterIsActive != null) this.query = this.query + "&filterIsActive=" + this.input.filterIsActive
           

            this.$axios.get("gadai-reject-reason/"+this.query).then(response => {
                this.alasan = response.data.data
        
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },

        confSwitchStatus(id){
            this.activeId = id
            this.$bvModal.show('conf-switch-status')
        },

        //----------------- Fungsi Pagination, Sorting, dan Filtering -----------------

        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getAlasan()
        },

        onPageChange(){
            if (this.loading == false){
             
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getAlasan()
            }
        },

        onReset(){
            this.input.filterName = ""
            this.input.filterIsActive = null
            this.input.filterRequirePhoto = null
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getAlasan()
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy(){
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

         updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        inputalasan(){
            this.$bvModal.show("modal-tambah-alasan")
        },

        inputSE(){
            this.$router.push({path: `${this.$route.path}/inputSE`});
        },

        editalasan(row){
            this.activeId = row.id
            this.formEdit.alasan = row.name
            this.formEdit.requireFoto = (row.requirePhoto.toString().toLowerCase() == "true")
            this.$bvModal.show("modal-edit-alasan")
        },

        confirmInput(){
            if(this.form.alasan == null || this.form.alasan == ""){
                return this.$helper.toastErr(this, "Mohon isi Nama alasan terlebih dahulu!")
            }
            this.$bvModal.show("modal-confirm-input")
        },

        submit(){
            let payload = new FormData()
            payload.append("name", this.form.alasan)
            payload.append("requirePhoto", this.form.requireFoto)

            this.$axios.post('gadai-reject-reason/', payload, { timeout: 300000 }).then(response => {
                this.form.alasan = ""
                this.$helper.toastSucc(this, "alasan berhasil ditambahkan!")
                this.$bvModal.hide("modal-confirm-input")
                this.$bvModal.hide("modal-tambah-alasan")
                this.getAlasan()
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.isSubmitting = false
            })
            .finally(() => {
                // this.isSubmitting = false
            })

        },

        confirmEdit(){
            if(this.formEdit.alasan == null || this.formEdit.alasan == ""){
                return this.$helper.toastErr(this, "Mohon isi Nama alasan terlebih dahulu!")
            }
            this.$bvModal.show("modal-confirm-edit")
        },

        submitEdit(){
           
            let payload = new FormData()
            payload.append("id", this.activeId)
            payload.append("name", this.formEdit.alasan)
            payload.append("requirePhoto", this.formEdit.requireFoto)

            this.$axios.post('gadai-reject-reason/', payload, { timeout: 300000 }).then(response => {
                this.formEdit.alasan = ""
                this.$helper.toastSucc(this, "alasan berhasil diubah!")
                this.$bvModal.hide("modal-confirm-edit")
                this.$bvModal.hide("modal-edit-alasan")
                this.getAlasan()
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.isSubmitting = false
            })
            .finally(() => {
                // this.isSubmitting = false
            })

        },


        onSwitchStatus(){
            this.isSubmitting = true

            this.$axios.post(`gadai-reject-reason/switch-active?id=${this.activeId}`).then(response => {
                // this.$helper.toastSucc(this, " diubah!")
                this.$bvModal.hide("conf-switch-status")
                this.getAlasan()
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        }
    },
    created(){
        this.init()
    }
}
</script>
